import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3129252"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-outer" }
const _hoisted_2 = {
  key: 0,
  class: "table table-row-dashed table-row-gray-200 align-middle"
}
const _hoisted_3 = { class: "table table-row-dashed table-row-gray-200 align-middle" }
const _hoisted_4 = { class: "fw-semibold text-gray-600" }
const _hoisted_5 = {
  class: "text-center",
  style: {"border-bottom":"1px solid #000"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "table-title-gray" }, null, -1))
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "typeBadge" }
const _hoisted_9 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "d-flex justify-content-around pb-7" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center fs-2" }, "FOREX", -1))
const _hoisted_14 = { class: "fs-5 w-80px me-3" }
const _hoisted_15 = ["name", "value"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-5" }, "%", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center fs-2" }, "GOLD", -1))
const _hoisted_18 = { class: "fs-5 w-80px me-3" }
const _hoisted_19 = ["name", "value"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-5" }, "%", -1))
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center fs-3 mt-11" }, " For setting please see the second IB ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center fs-3 mt-5" }, " 设置请查看二級 IB ", -1))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { class: "d-flex justify-content-between mt-5 mb-5" }
const _hoisted_26 = { class: "d-flex" }
const _hoisted_27 = { class: "d-flex" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 0,
  class: "seperateLine"
}
const _hoisted_30 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "d-flex align-items-center" }
const _hoisted_33 = { class: "me-3" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-3" }, "Form Check", -1))
const _hoisted_35 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_36 = {
  key: 1,
  class: "fa-solid fa-circle",
  style: {"color":"green"}
}
const _hoisted_37 = {
  key: 2,
  class: "fa-solid fa-circle fa-fade",
  style: {"color":"red"}
}
const _hoisted_38 = {
  key: 3,
  class: "fa-solid fa-circle",
  style: {"color":"lightgray"}
}
const _hoisted_39 = { class: "table table-row-dashed table-row-gray-200 align-middle" }
const _hoisted_40 = { class: "fw-semibold text-gray-600" }
const _hoisted_41 = {
  class: "text-center",
  style: {"border-bottom":"1px solid #000"}
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "table-title-gray" }, null, -1))
const _hoisted_43 = { class: "mb-2" }
const _hoisted_44 = { class: "typeBadge" }
const _hoisted_45 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_46 = {
  class: "text-center",
  style: {"border-bottom":"1px solid #000"}
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "table-title-gray" }, null, -1))
const _hoisted_48 = { key: 0 }
const _hoisted_49 = {
  key: 0,
  class: "d-flex flex-column align-items-center"
}
const _hoisted_50 = { class: "mt-3" }
const _hoisted_51 = {
  key: 1,
  class: "d-flex flex-column justify-content-center align-items-center"
}
const _hoisted_52 = { style: {"width":"150px"} }
const _hoisted_53 = { class: "d-flex align-items-center" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "me-3" }, "Pips", -1))
const _hoisted_55 = { class: "d-flex justify-content-center align-items-center mt-3" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "me-3" }, "Com", -1))
const _hoisted_57 = { key: 1 }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = {
  class: "text-center",
  style: {"border-bottom":"1px solid #000"}
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "table-title-gray" }, null, -1))
const _hoisted_62 = {
  key: 0,
  class: "d-flex flex-column justify-content-center align-items-center"
}
const _hoisted_63 = { key: 2 }
const _hoisted_64 = { class: "text-center" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_66 = ["onClick"]
const _hoisted_67 = { key: 1 }

import { ref, onMounted } from "vue";
import { UserRoleTypes } from "@/core/types/RoleTypes";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import AccountService from "../services/AccountService";
import RebateService from "../../rebate/services/RebateService";
import { processKeysToCamelCase } from "@/core/services/api.client";
import AddTopAgentAccountType from "./modal/AddTopAgentAccountType.vue";
import CheckRebateSetting from "./modal/CheckRebateSetting.vue";
import { RebateDistributionTypes } from "@/core/types/RebateDistributionTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountRebateRelation',
  props: {
    accountId: {}
  },
  setup(__props: any) {

const props = __props;



const isLoading = ref(true);
const checkingTypes = {
  isChecking: 0,
  passed: 1,
  failed: 2,
  noNeed: 3,
};
const checkingStatus = ref(0);
const rebateInfo = ref({} as any);
const selectedAccountType = ref(0);
const accountInfo = ref({} as any);
const relationList = ref([] as any);
const accountDetail = ref({} as any);
const allAccountType = ref([] as any);
const defaultRebateRate = ref({} as any);
const defaultRebateRateForNewAccountType = ref({} as any);
const productCategory = ref(Array<any>());
const availableAccountType = ref([] as any);
const topIbRebateInfo = ref();
const distributionInfo = ref({} as any);
const hasAgentRule = ref(false);

const AddTopAgentAccountTypeRef =
  ref<InstanceType<typeof AddTopAgentAccountType>>();

const CheckRebateSettingRef = ref<InstanceType<typeof CheckRebateSetting>>();

const addTopAgentAccountType = async (_accountUid) => {
  AddTopAgentAccountTypeRef.value?.show(
    rebateInfo.value[_accountUid].id,
    selectedAccountType.value,
    productCategory.value,
    defaultRebateRateForNewAccountType.value
  );
};

const addAgentAccountType = async (_accountUid) => {
  const requestObject =
    rebateInfo.value[
      relationList.value.find((acc) => acc.uid == _accountUid).upperAcc
    ].calculatedLevelSetting.allowedAccounts[selectedAccountType.value];

  requestObject.pips = null;
  requestObject.commission = null;
  requestObject.allowPips = [];
  requestObject.allowCommissions = [];
  requestObject.percentage = 100;

  try {
    await RebateService.updateAgentRule(
      rebateInfo.value[_accountUid].id,
      JSON.parse(JSON.stringify(requestObject))
    );
    MsgPrompt.success("Update Success").then(() => {
      buildRelationForm();
    });
  } catch (error) {
    console.log(error);
  }
};

const updateTopAgentRule = async (_accountUid) => {
  if (!_accountUid) return;
  const requestObject =
    rebateInfo.value[_accountUid]?.levelSetting.allowedAccounts[
      selectedAccountType.value
    ];

  try {
    await RebateService.updateTopAgentRule(
      rebateInfo.value[_accountUid].id,
      JSON.parse(JSON.stringify(requestObject))
    );
    MsgPrompt.success("Update Success").then(() => {
      buildRelationForm();
    });
  } catch (error) {
    console.log(error);
  }
};

const updateAgentRule = async (_accountUid) => {
  if (!rebateInfo.value[_accountUid]?.schema[selectedAccountType.value]) return;

  let requestObject =
    rebateInfo.value[_accountUid]?.schema[selectedAccountType.value];
  requestObject.accountType = selectedAccountType.value;

  try {
    await RebateService.updateAgentRule(
      rebateInfo.value[_accountUid].id,
      JSON.parse(JSON.stringify(requestObject))
    );
    MsgPrompt.success("Update Success").then(() => {
      buildRelationForm();
    });
  } catch (error) {
    console.log(error);
  }
};

const updateRebateRule = async (_accountUid) => {
  const accountRole = accountInfo.value[_accountUid].role;
  const isRoot = rebateInfo.value[_accountUid]?.isRoot;
  const hasBelowAcc = relationList.value.find(
    (acc) => acc.uid === _accountUid
  )?.belowAcc;

  if (accountRole === UserRoleTypes.Sales) {
    updateTopAgentRule(hasBelowAcc);
  } else {
    if (isRoot) {
      updateTopAgentRule(_accountUid);
    } else {
      updateAgentRule(_accountUid);
    }
    updateAgentRule(hasBelowAcc);
  }
};

// =========================================================================================================
// =========================================================================================================

const buildRelationForm = async () => {
  isLoading.value = true;
  relationList.value = [];
  const _referPath = accountDetail.value.referPathUids;

  try {
    const [getCategory, getDefaultLevelSetting, queryAccounts, getAgentRules] =
      await Promise.all([
        RebateService.getRebateCategory(),
        RebateService.getDefaultLevelSetting(
          accountDetail.value.salesAccountId ?? accountDetail.value.id
        ).then((result) => processKeysToCamelCase(result)),
        AccountService.queryAccounts({
          uids: _referPath,
          size: 100,
        }),
        RebateService.getAgentRules({
          agentUids: _referPath,
        }),
      ]);

    accountInfo.value = queryAccounts.data.reduce((acc, cur) => {
      acc[cur["uid"]] = cur;
      return acc;
    }, {});

    productCategory.value = getCategory;
    rebateInfo.value = adjustRebateInfo(getAgentRules.data);
    defaultRebateRateForNewAccountType.value = JSON.parse(
      JSON.stringify(getDefaultLevelSetting)
    );
    defaultRebateRate.value = adjustDefaultRebateRate(getDefaultLevelSetting);
    allAccountType.value = Object.keys(defaultRebateRate.value);

    if (getAgentRules.data.length != 0) {
      hasAgentRule.value = true;
      distributionInfo.value = getAgentRules.data[0];
    }
  } catch (error) {
    // MsgPrompt.error(t("error.oopsErrorAccured"), "5263");
  }

  _referPath.forEach((uid) => {
    relationList.value.push({
      uid: uid,
      role: accountInfo.value[uid].role,
      upperAcc: _referPath[_referPath.indexOf(uid) - 1] ?? null,
      belowAcc: _referPath[_referPath.indexOf(uid) + 1] ?? null,
    });
  });

  const _lastAccount = relationList.value[relationList.value.length - 1];

  availableAccountType.value = {
    [UserRoleTypes.Sales]: Object.keys(defaultRebateRate.value),
    [UserRoleTypes.IB]: Object.keys(
      rebateInfo.value[_lastAccount.uid]?.calculatedLevelSetting
        .allowedAccounts ?? {}
    ),
    [UserRoleTypes.Client]: [
      accountInfo.value[_lastAccount.uid].type.toString(),
    ],
  }[_lastAccount.role];

  if (selectedAccountType.value == 0) {
    selectedAccountType.value = availableAccountType.value[0];
  }

  // console.log("_referPath", _referPath);
  // console.log("accountInfo", accountInfo.value);
  // console.log("allAccountType", allAccountType.value);
  // console.log(
  //   "defaultRebateRateForNewAccountType",
  //   defaultRebateRateForNewAccountType.value
  // );
  // console.log("defaultRebateRate", defaultRebateRate.value);
  // console.log("selectedAccountType.value", selectedAccountType.value);

  if (Object.values(rebateInfo.value).find((acc: any) => acc.isRoot)) {
    checkingStatus.value = checkingTypes.isChecking;
    CheckRebateSettingRef.value?.onCheck(
      relationList.value,
      rebateInfo.value,
      defaultRebateRateForNewAccountType.value
    );
  } else {
    isLoading.value = false;
    updateCheckingStatus(checkingTypes.noNeed);
  }
};

// =========================================================================================================
// =========================================================================================================

const adjustDefaultRebateRate = (_data) => {
  topIbRebateInfo.value = Object.values(rebateInfo.value).find(
    (acc: any) => acc.isRoot
  );

  Object.keys(_data).forEach((acc) => {
    _data[acc] =
      _data[acc].find(
        (option) =>
          option.optionName ==
          topIbRebateInfo.value?.levelSetting.allowedAccounts[acc]?.optionName
      ) ?? _data[acc][0];

    _data[acc].allowPipOptions = [
      ...new Set([
        ..._data[acc].allowPipOptions,
        ...(topIbRebateInfo.value?.calculatedLevelSetting.allowedAccounts[acc]
          ?.allowPips ?? []),
      ]),
    ];

    _data[acc].allowCommissionOptions = [
      ...new Set([
        ..._data[acc].allowCommissionOptions,
        ...(topIbRebateInfo.value?.calculatedLevelSetting.allowedAccounts[acc]
          ?.allowCommissions ?? []),
      ]),
    ];
  });

  return _data;
};

const adjustRebateInfo = (_data) => {
  const convertArrayToObject = (rules) => {
    return rules.reduce((acc, cur) => {
      acc[cur.accountType] = cur;
      return acc;
    }, {});
  };

  _data.forEach((acc) => {
    acc.schema = convertArrayToObject(acc.schema);
    acc.levelSetting.allowedAccounts = convertArrayToObject(
      acc.levelSetting.allowedAccounts
    );
    acc.calculatedLevelSetting.allowedAccounts = convertArrayToObject(
      acc.calculatedLevelSetting.allowedAccounts
    );
  });

  _data = _data.reduce((acc, cur) => {
    acc[cur["agentAccountUid"]] = cur;
    return acc;
  }, {});

  return _data;
};

const updateCheckingStatus = (_status) => {
  isLoading.value = false;
  checkingStatus.value = _status;

  // if (_status == checkingTypes.failed) {
  //   CheckRebateSettingRef.value?.show();
  // }
};

const viewCheckResult = () => {
  CheckRebateSettingRef.value?.show();
};

onMounted(async () => {
  try {
    accountDetail.value = await AccountService.getAccountDetailById(
      props.accountId
    );
    buildRelationForm();
  } catch (error) {
    // MsgPrompt.error(t("error.oopsErrorAccured"), "5263");
  }
});

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox_button = _resolveComponent("el-checkbox-button")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
            _createElementVNode("tbody", null, [
              _createVNode(_component_LoadingRing)
            ])
          ]))
        : (
        !isLoading.value &&
        distributionInfo.value.levelSetting?.distributionType ==
          _unref(RebateDistributionTypes).LevelSet
      )
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("table", _hoisted_3, [
                _createElementVNode("tbody", _hoisted_4, [
                  _createElementVNode("tr", _hoisted_5, [
                    _hoisted_6,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relationList.value, ({ uid }, index) => {
                      return (_openBlock(), _createElementBlock("td", {
                        class: "table-title-gray",
                        key: index,
                        style: {"position":"relative"}
                      }, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("type.roleType." + accountInfo.value[uid].role)), 1),
                          _createTextVNode(": " + _toDisplayString(accountInfo.value[uid].user.displayName), 1)
                        ]),
                        _createElementVNode("span", _hoisted_8, _toDisplayString(uid), 1),
                        (
                  rebateInfo.value[uid] &&
                  rebateInfo.value[uid].calculatedLevelSetting.allowedAccounts
                )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rebateInfo.value[uid].calculatedLevelSetting
                    .allowedAccounts, (acc, index) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  class: _normalizeClass(["accountBadge me-1", ['type1', 'type2', 'type3'][index % 3]]),
                                  key: 'type_' + index
                                }, _toDisplayString(_ctx.$t("type.shortAccount." + acc.accountType)), 3))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _hoisted_10,
              (
          hasAgentRule.value &&
          distributionInfo.value.levelSetting.percentageSetting.length != 0
        )
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", null, [
                        _hoisted_13,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(distributionInfo.value.levelSetting
                .percentageSetting.FOREX, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "d-flex align-items-center mt-5"
                          }, [
                            _createElementVNode("label", _hoisted_14, "Level " + _toDisplayString(index + 1), 1),
                            _createElementVNode("input", {
                              class: "form-control form-control-solid w-200px h-55px",
                              name: 'ibLinkSetting' + index,
                              value: item,
                              disabled: ""
                            }, null, 8, _hoisted_15),
                            _hoisted_16
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_17,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(distributionInfo.value.levelSetting
                .percentageSetting.GOLD, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "d-flex align-items-center mt-5"
                          }, [
                            _createElementVNode("label", _hoisted_18, "Level " + _toDisplayString(index + 1), 1),
                            _createElementVNode("input", {
                              class: "form-control form-control-solid w-200px h-55px",
                              name: 'ibLinkSetting' + index,
                              value: item,
                              disabled: ""
                            }, null, 8, _hoisted_19),
                            _hoisted_20
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_24))
            ], 64))
          : (!isLoading.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allAccountType.value, (accountType, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          (availableAccountType.value.includes(accountType))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["accountTypeBtn", {
                  'active-accountTypeBtn': selectedAccountType.value == accountType,
                }]),
                                onClick: ($event: any) => (selectedAccountType.value = accountType)
                              }, _toDisplayString(_ctx.$t("type.account." + accountType)), 11, _hoisted_28))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    (accountDetail.value.role != _unref(UserRoleTypes).Client)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29))
                      : _createCommentVNode("", true),
                    (accountDetail.value.role != _unref(UserRoleTypes).Client)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allAccountType.value, (accountType, index) => {
                            return (_openBlock(), _createElementBlock("div", { key: index }, [
                              (!availableAccountType.value.includes(accountType))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["unAvailableAccountTypeBtn", {
                  'active-accountTypeBtn': selectedAccountType.value == accountType,
                }]),
                                    onClick: ($event: any) => (selectedAccountType.value = accountType)
                                  }, _toDisplayString(_ctx.$t("type.account." + accountType)), 11, _hoisted_31))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("span", _hoisted_33, [
                      _createVNode(_component_el_button, {
                        onClick: viewCheckResult,
                        disabled: checkingStatus.value == checkingTypes.noNeed
                      }, {
                        default: _withCtx(() => [
                          _hoisted_34,
                          (checkingStatus.value == checkingTypes.isChecking)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_35))
                            : (checkingStatus.value == checkingTypes.passed)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_36))
                              : (checkingStatus.value == checkingTypes.failed)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_37))
                                : (checkingStatus.value == checkingTypes.noNeed)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_38))
                                  : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ])
                  ])
                ]),
                _createElementVNode("table", _hoisted_39, [
                  _createElementVNode("tbody", _hoisted_40, [
                    _createElementVNode("tr", _hoisted_41, [
                      _hoisted_42,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relationList.value, ({ uid }, index) => {
                        return (_openBlock(), _createElementBlock("td", {
                          class: "table-title-gray",
                          key: index,
                          style: {"position":"relative"}
                        }, [
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("type.roleType." + accountInfo.value[uid].role)), 1),
                            _createTextVNode(": " + _toDisplayString(accountInfo.value[uid].user.displayName), 1)
                          ]),
                          _createElementVNode("span", _hoisted_44, _toDisplayString(uid), 1),
                          (
                  rebateInfo.value[uid] &&
                  rebateInfo.value[uid].calculatedLevelSetting.allowedAccounts
                )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rebateInfo.value[uid].calculatedLevelSetting
                    .allowedAccounts, (acc, index) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    class: _normalizeClass(["accountBadge me-1", ['type1', 'type2', 'type3'][index % 3]]),
                                    key: 'type_' + index
                                  }, _toDisplayString(_ctx.$t("type.shortAccount." + acc.accountType)), 3))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("tr", _hoisted_46, [
                      _hoisted_47,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relationList.value, ({ uid, upperAcc }, index) => {
                        return (_openBlock(), _createElementBlock("td", {
                          class: "table-title-gray",
                          key: index
                        }, [
                          (
                  rebateInfo.value[uid]?.calculatedLevelSetting.allowedAccounts[
                    selectedAccountType.value
                  ]
                )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                (rebateInfo.value[uid].isRoot)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("div", null, _toDisplayString(_ctx.$t("fields.whichPips")), 1),
                                        _createVNode(_component_el_checkbox_group, {
                                          modelValue: 
                        rebateInfo.value[uid].levelSetting.allowedAccounts[
                          selectedAccountType.value
                        ].allowPips
                      ,
                                          "onUpdate:modelValue": ($event: any) => ((
                        rebateInfo.value[uid].levelSetting.allowedAccounts[
                          selectedAccountType.value
                        ].allowPips
                      ) = $event),
                                          size: "small",
                                          style: {"width":"180px"}
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(defaultRebateRate.value[selectedAccountType.value]
                          .allowPipOptions, (option) => {
                                              return (_openBlock(), _createBlock(_component_el_checkbox_button, {
                                                key: option,
                                                label: option
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(option), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["label"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _createElementVNode("div", _hoisted_50, [
                                        _createElementVNode("div", null, _toDisplayString(_ctx.$t("fields.whichCommission")), 1),
                                        _createVNode(_component_el_checkbox_group, {
                                          modelValue: 
                        rebateInfo.value[uid].levelSetting.allowedAccounts[
                          selectedAccountType.value
                        ].allowCommissions
                      ,
                                          "onUpdate:modelValue": ($event: any) => ((
                        rebateInfo.value[uid].levelSetting.allowedAccounts[
                          selectedAccountType.value
                        ].allowCommissions
                      ) = $event),
                                          size: "small",
                                          style: {"width":"180px"}
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(defaultRebateRate.value[selectedAccountType.value]
                          .allowCommissionOptions, (option) => {
                                              return (_openBlock(), _createBlock(_component_el_checkbox_button, {
                                                key: option,
                                                label: option
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(option), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["label"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue"])
                                      ])
                                    ]))
                                  : (accountInfo.value[uid].role == _unref(UserRoleTypes).IB)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                        _createElementVNode("div", _hoisted_52, [
                                          _createElementVNode("div", _hoisted_53, [
                                            _hoisted_54,
                                            _createVNode(_component_el_select, {
                                              modelValue: 
                          rebateInfo.value[uid].schema[selectedAccountType.value].pips
                        ,
                                              "onUpdate:modelValue": ($event: any) => ((
                          rebateInfo.value[uid].schema[selectedAccountType.value].pips
                        ) = $event),
                                              placeholder: "Select",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(), _createBlock(_component_el_option, {
                                                  key: 'Clear',
                                                  label: 'Clear',
                                                  value: -1,
                                                  onClick: ($event: any) => (
                            rebateInfo.value[uid].schema[selectedAccountType.value].pips =
                              null
                          )
                                                }, null, 8, ["onClick"])),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topIbRebateInfo.value.calculatedLevelSetting
                            .allowedAccounts[selectedAccountType.value].allowPips, (item) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: item,
                                                    label: item,
                                                    value: item,
                                                    onClick: ($event: any) => (
                            rebateInfo.value[uid].schema[
                              selectedAccountType.value
                            ].commission = null
                          )
                                                  }, null, 8, ["label", "value", "onClick"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _createElementVNode("div", _hoisted_55, [
                                            _hoisted_56,
                                            _createVNode(_component_el_select, {
                                              modelValue: 
                          rebateInfo.value[uid].schema[selectedAccountType.value].commission
                        ,
                                              "onUpdate:modelValue": ($event: any) => ((
                          rebateInfo.value[uid].schema[selectedAccountType.value].commission
                        ) = $event),
                                              placeholder: "Select",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(), _createBlock(_component_el_option, {
                                                  key: 'Clear',
                                                  label: 'Clear',
                                                  value: -1,
                                                  onClick: ($event: any) => (
                            rebateInfo.value[uid].schema[
                              selectedAccountType.value
                            ].commission = null
                          )
                                                }, null, 8, ["onClick"])),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topIbRebateInfo.value.calculatedLevelSetting
                            .allowedAccounts[selectedAccountType.value]
                            .allowCommissions, (item) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: item,
                                                    label: item,
                                                    value: item,
                                                    onClick: ($event: any) => (
                            rebateInfo.value[uid].schema[selectedAccountType.value].pips =
                              null
                          )
                                                  }, null, 8, ["label", "value", "onClick"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                (
                    selectedAccountType.value != undefined &&
                    accountInfo.value[uid].role == _unref(UserRoleTypes).IB &&
                    rebateInfo.value[uid].calculatedLevelSetting.allowedAccounts[
                      selectedAccountType.value
                    ] == undefined &&
                    rebateInfo.value[upperAcc]?.calculatedLevelSetting
                      .allowedAccounts[selectedAccountType.value]
                  )
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "btn btn-sm btn-light-primary border-0",
                                      onClick: ($event: any) => (addAgentAccountType(uid))
                                    }, " Add " + _toDisplayString(_ctx.$t("type.account." + selectedAccountType.value)), 9, _hoisted_58))
                                  : _createCommentVNode("", true),
                                (
                    selectedAccountType.value != undefined &&
                    accountInfo.value[uid].role == _unref(UserRoleTypes).IB &&
                    rebateInfo.value[uid].calculatedLevelSetting.allowedAccounts[
                      selectedAccountType.value
                    ] == undefined &&
                    rebateInfo.value[uid].isRoot
                  )
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      class: "btn btn-sm btn-light-primary border-0",
                                      onClick: ($event: any) => (addTopAgentAccountType(uid))
                                    }, " Add " + _toDisplayString(_ctx.$t("type.account." + selectedAccountType.value)), 9, _hoisted_59))
                                  : _createCommentVNode("", true)
                              ]))
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("tr", _hoisted_60, [
                      _hoisted_61,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relationList.value, ({ uid, belowAcc }, index) => {
                        return (_openBlock(), _createElementBlock("td", {
                          class: "table-title-gray",
                          key: index
                        }, [
                          (
                  accountInfo.value[uid].role == _unref(UserRoleTypes).IB &&
                  rebateInfo.value[belowAcc] &&
                  rebateInfo.value[belowAcc].schema[selectedAccountType.value]
                )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                _createElementVNode("div", null, _toDisplayString(_ctx.$t("fields.howMuchTake")), 1),
                                _createElementVNode("div", null, [
                                  _createVNode(_component_el_input, {
                                    style: {"width":"150px"},
                                    type: "text",
                                    modelValue: 
                      rebateInfo.value[belowAcc].schema[selectedAccountType.value]
                        .percentage
                    ,
                                    "onUpdate:modelValue": ($event: any) => ((
                      rebateInfo.value[belowAcc].schema[selectedAccountType.value]
                        .percentage
                    ) = $event)
                                  }, {
                                    append: _withCtx(() => [
                                      _createTextVNode("%")
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue"])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productCategory.value, (category, p_index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: "text-center",
                        key: p_index
                      }, [
                        _createElementVNode("td", null, _toDisplayString(category.value), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relationList.value, ({ uid, belowAcc }, a_index) => {
                          return (_openBlock(), _createElementBlock("td", { key: a_index }, [
                            (
                  belowAcc &&
                  accountInfo.value[uid].role == _unref(UserRoleTypes).Sales &&
                  rebateInfo.value[belowAcc]?.levelSetting.allowedAccounts[
                    selectedAccountType.value
                  ]
                )
                              ? (_openBlock(), _createBlock(_component_el_input, {
                                  key: 0,
                                  class: "w-100px",
                                  modelValue: 
                  rebateInfo.value[belowAcc].levelSetting.allowedAccounts[
                    selectedAccountType.value
                  ].items.find((acc) => acc.cid == category.key).r
                ,
                                  "onUpdate:modelValue": ($event: any) => ((
                  rebateInfo.value[belowAcc].levelSetting.allowedAccounts[
                    selectedAccountType.value
                  ].items.find((acc) => acc.cid == category.key).r
                ) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                              : (
                  belowAcc &&
                  accountInfo.value[uid].role == _unref(UserRoleTypes).IB &&
                  accountInfo.value[belowAcc].role == _unref(UserRoleTypes).IB &&
                  rebateInfo.value[belowAcc]?.schema[selectedAccountType.value]
                )
                                ? (_openBlock(), _createBlock(_component_el_input, {
                                    key: 1,
                                    class: "w-100px",
                                    modelValue: 
                  rebateInfo.value[belowAcc].schema[selectedAccountType.value].items.find(
                    (acc) => acc.cid == category.key
                  ).r
                ,
                                    "onUpdate:modelValue": ($event: any) => ((
                  rebateInfo.value[belowAcc].schema[selectedAccountType.value].items.find(
                    (acc) => acc.cid == category.key
                  ).r
                ) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                : (
                  accountInfo.value[uid].role == _unref(UserRoleTypes).IB &&
                  (!belowAcc ||
                    (belowAcc &&
                      accountInfo.value[belowAcc].role == _unref(UserRoleTypes).Client))
                )
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString(rebateInfo.value[uid].calculatedLevelSetting.allowedAccounts[
                    selectedAccountType.value
                  ]?.items.find((acc) => acc.cid == category.key).r), 1))
                                  : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    }), 128)),
                    _createElementVNode("tr", _hoisted_64, [
                      _hoisted_65,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relationList.value, ({ uid, belowAcc }, index) => {
                        return (_openBlock(), _createElementBlock("td", { key: index }, [
                          (
                  ((accountInfo.value[uid].role == _unref(UserRoleTypes).Sales ||
                    accountInfo.value[uid].role == _unref(UserRoleTypes).IB) &&
                    rebateInfo.value[belowAcc]?.calculatedLevelSetting
                      .allowedAccounts[selectedAccountType.value]) ||
                  rebateInfo.value[uid]?.calculatedLevelSetting.allowedAccounts[
                    selectedAccountType.value
                  ]
                )
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-sm btn-light-primary border-0",
                                onClick: ($event: any) => (updateRebateRule(uid))
                              }, " Update ", 8, _hoisted_66))
                            : (_openBlock(), _createElementBlock("span", _hoisted_67))
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true)
    ]),
    _createVNode(AddTopAgentAccountType, {
      ref_key: "AddTopAgentAccountTypeRef",
      ref: AddTopAgentAccountTypeRef,
      onBuildRelationForm: buildRelationForm
    }, null, 512),
    _createVNode(CheckRebateSetting, {
      ref_key: "CheckRebateSettingRef",
      ref: CheckRebateSettingRef,
      onUpdateCheckingStatus: updateCheckingStatus,
      onBuildRelationForm: buildRelationForm
    }, null, 512)
  ], 64))
}
}

})